import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <h1>Integritetspolicy</h1>
        <p>Senast uppdaterad: 2025-12-19</p>
      </header>

      <section className="privacy-section">
        <h2>1. Personuppgiftsansvarig</h2>
        <p>
          <strong>Ejbe Vision AB</strong><br />
          Organisationsnummer: 559417-8993<br />
          E-post: mattias@projektledarpodden.se<br />
          Webb: projektledarpodden.se
        </p>
      </section>

      <section className="privacy-section">
        <h2>2. Vilka uppgifter samlar vi in?</h2>
        <p>När du bokar en kurs samlar vi in följande uppgifter:</p>
        <ul>
          <li><strong>Kontaktuppgifter:</strong> Namn, e-postadress, telefonnummer</li>
          <li><strong>Företagsinformation:</strong> Företagsnamn (för fakturering)</li>
          <li><strong>Bokningsinformation:</strong> Vilken kurs du bokar, datum, eventuella kommentarer</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>3. Varför samlar vi in uppgifterna?</h2>
        <table className="privacy-table">
          <thead>
            <tr>
              <th>Ändamål</th>
              <th>Laglig grund</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Genomföra din kursbokning</td>
              <td>Avtal (nödvändigt för att leverera tjänsten)</td>
            </tr>
            <tr>
              <td>Skicka bokningsbekräftelse och kursinformation</td>
              <td>Avtal</td>
            </tr>
            <tr>
              <td>Fakturering</td>
              <td>Rättslig förpliktelse (bokföringslagen)</td>
            </tr>
            <tr>
              <td>Skicka kurspåminnelser</td>
              <td>Berättigat intresse</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="privacy-section">
        <h2>4. Hur länge sparar vi uppgifterna?</h2>
        <ul>
          <li><strong>Bokningsuppgifter:</strong> Sparas så länge du är aktiv kund, därefter raderas de på begäran</li>
          <li><strong>Faktureringsuppgifter:</strong> Sparas i 7 år enligt bokföringslagen</li>
          <li><strong>Kontaktuppgifter:</strong> Raderas inom 30 dagar efter begäran</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>5. Vilka delar vi uppgifterna med?</h2>
        <p>Vi delar endast dina uppgifter med:</p>
        <ul>
          <li><strong>Microsoft Azure:</strong> Hosting av vår tjänst (servrar i EU)</li>
          <li><strong>Microsoft 365:</strong> E-postutskick av bokningsbekräftelser</li>
        </ul>
        <p>Vi säljer aldrig dina uppgifter till tredje part.</p>
      </section>

      <section className="privacy-section">
        <h2>6. Dina rättigheter</h2>
        <p>Enligt GDPR har du rätt att:</p>
        <ul>
          <li><strong>Få tillgång</strong> till dina personuppgifter</li>
          <li><strong>Rätta</strong> felaktiga uppgifter</li>
          <li><strong>Radera</strong> dina uppgifter ("rätten att bli glömd")</li>
          <li><strong>Begränsa</strong> behandlingen av dina uppgifter</li>
          <li><strong>Dataportabilitet</strong> – få ut dina uppgifter i ett strukturerat format</li>
          <li><strong>Invända</strong> mot behandling</li>
        </ul>
        <p>
          För att utöva dina rättigheter, kontakta oss på{' '}
          <a href="mailto:mattias@projektledarpodden.se">mattias@projektledarpodden.se</a>.
          Vi svarar inom 30 dagar.
        </p>
      </section>

      <section className="privacy-section">
        <h2>7. Säkerhet</h2>
        <p>Vi skyddar dina uppgifter genom:</p>
        <ul>
          <li>Krypterad överföring (HTTPS/TLS)</li>
          <li>Krypterad lagring i Microsoft Azure</li>
          <li>Begränsad åtkomst till personuppgifter</li>
          <li>Regelbundna säkerhetsgranskningar</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>8. Cookies</h2>
        <p>
          Vår bokningssida använder endast nödvändiga tekniska cookies för att tjänsten
          ska fungera. Vi använder inga spårningscookies eller tredjepartscookies för marknadsföring.
        </p>
      </section>

      <section className="privacy-section">
        <h2>9. Klagomål</h2>
        <p>
          Om du är missnöjd med hur vi hanterar dina personuppgifter har du rätt att
          lämna klagomål till Integritetsskyddsmyndigheten (IMY):
        </p>
        <p>
          <strong>Integritetsskyddsmyndigheten</strong><br />
          Box 8114, 104 20 Stockholm<br />
          E-post: imy@imy.se<br />
          Webb: <a href="https://www.imy.se" target="_blank" rel="noopener noreferrer">www.imy.se</a>
        </p>
      </section>

      <section className="privacy-section">
        <h2>10. Kontakt</h2>
        <p>
          Har du frågor om vår behandling av personuppgifter? Kontakta oss:
        </p>
        <p>
          <strong>Ejbe Vision AB</strong><br />
          E-post: <a href="mailto:mattias@projektledarpodden.se">mattias@projektledarpodden.se</a>
        </p>
      </section>

      <footer className="privacy-footer">
        <a href="/boka">← Tillbaka till bokning</a>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
